import React from "react";

export const LawSvg = (props) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 12.3 14.3"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1 4.9v8.5a1.8 1.8 0 01-1.8 1.8v-.9a.9.9 0 00.9-.9V4.9h-1.8a1.3 1.3 0 01-1.3-1.4V1.7H5.2a.9.9 0 00-.9.9v8.1h-.9V2.6A1.8 1.8 0 015.2.8h4.9zM4.3 14.7v.3H1.9v-3.6h.4v3.2h2z"
        transform="translate(-1.9 -.8)"
      ></path>
      <path
        d="M7.8 14.8v.2h-.5l-.3-.7H5.3l-.3.6h-.4v-.2a.1.1 0 00.1-.1L6 11.4l.2-.2c.2 0 .2.1.3.2l1.3 3.2a.1.1 0 000 .2zm-1-1l-.6-1.7-.7 1.7zM11.8 11.4c.1 0 .1.1.1.2l-1 3.2h-.5L9.7 12 9 14.9h-.5l-1-3.2v-.2h.4l.8 2.8.7-2.7v-.2h.3v.2l.7 2.7.8-2.8h.4z"
        transform="translate(-1.9 -.8)"
      ></path>
    </svg>
  );
}
